import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { UserDataViewModel } from '../../../buscadores/solicitudes/buscador-solicitud-cam.types';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';
import { EnumCodigosTwTcAcciones } from 'src/app/components/_importacion/solicitudes/types/enum';
import { TwInspeccionCamViewModel } from '../../inspeccion.types';
import { proxiedPropertiesOf } from 'src/app/components/core/_infrastructure/types/utils';
import { TwUnidadInspeccionViewModelExtended } from '../../unidad-inspeccion-datosbasicos.types';

@Component({
    selector: 'app-inspeccion-ui-list',
    templateUrl: './inspeccion-ui-list.component.html',
    styleUrls: ['./inspeccion-ui-list.component.scss'],
})
export class InspeccionUiListComponent extends ListBase implements OnInit, OnChanges {
    @Input() unidadInspeccion: TwUnidadInspeccionViewModelExtended;
    @Input() result: TwInspeccionCamViewModel[];
    @Input() title: { plural: string; singular: string };
    @Input() readonly: boolean;
    @Input() userData: UserDataViewModel;
    @Output() view = new EventEmitter<TwInspeccionCamViewModel>();
    @Output() delete = new EventEmitter<number>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    private indexLastInspeccionNoBorrada = -1;

    constructor(protected notificacionService: NotificationService) {
        super(notificacionService);
    }

    ngOnInit() {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        const inspeccionUI = proxiedPropertiesOf<TwInspeccionCamViewModel>();

        this.cols = [
            { field: 'Link', header: '', reduce: true },
            { field: 'Image', header: '', reduce: true },
            { field: inspeccionUI.Id, header: 'Id', display: 'none' },
            { field: inspeccionUI.FechaInspeccion, header: 'F. Inspección' },
            { field: inspeccionUI.Inspector, header: 'Inspector' },
            { field: inspeccionUI.DescripcionPeriodoInspeccion, header: 'Nombre Inspección' },
            { field: inspeccionUI.DescripcionTipoInspeccion, header: 'Tipo Inspección' },
            { field: inspeccionUI.DescripcionResultadoInspeccion, header: 'Resultado' },
            { field: inspeccionUI.FechaCaducidad, header: 'F. Caducidad' },
            { field: inspeccionUI.Observaciones, header: 'Observaciones' },
            { field: inspeccionUI.FechaBorrado, header: 'F. Borrado' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            //this.result = [...changes.result.currentValue];
            this.calculateLastInspeccionNoBorrada();
            this.loading = false;
            setTimeout(() => {
                if (this.turboTable) {
                    this.turboTable.first = 1 * this.result?.length;
                }
            }, 100);
        }
    }

    private calculateLastInspeccionNoBorrada(): void {
        this.indexLastInspeccionNoBorrada = -1;
        this.result?.forEach((value, index) => {
            if (value?.FechaBorrado === null && index > this.indexLastInspeccionNoBorrada) {
                this.indexLastInspeccionNoBorrada = index;
            }
        });
    }

    onDelete(item: TwInspeccionCamViewModel): void {
        if (!item.Id) {
            return;
        }
        this.delete.emit(item?.Id);
    }

    onView(item: TwInspeccionCamViewModel): void {
        this.view.emit(item);
    }

    /***
     * Este método indica si se puede eliminar la inspección.
     * @param item InspeccionUIItemViewModel
     * @return boolean
     */
    hasDeleteAccess(item: TwInspeccionCamViewModel): boolean {
        if (this.esInspeccionBorrada(item)) {
            return false;
        }

        if (!this.unidadInspeccion) {
            return false;
        }

        const hasAccess =
            this.userData?.loggedInUser?.getAction(EnumCodigosTwTcAcciones.REMOVE_INSPECCION_UI, this.unidadInspeccion?.IdEstadoUi).Editable || false;
        return hasAccess;
    }

    /***
     * Este método indica si se puede visualizar el detalle de la inspección
     * @param item InspeccionUIItemViewModel
     * @return boolean
     */
    hasViewAccess(item: TwInspeccionCamViewModel): boolean {
        const hasAccess = this.userData?.loggedInUser?.getAction(EnumCodigosTwTcAcciones.CONS_INSPECCION_UI).Visible || false;
        return hasAccess;
    }

    esInspeccionBorrada(item: TwInspeccionCamViewModel): boolean {
        if (item?.FechaBorrado !== null) {
            return true;
        }

        return false;
    }

    canBeDeleted(rowData: any, rowIndex: number): boolean {
        return this.hasDeleteAccess(rowData) && !this.readonly && this.result?.length > 0 && rowIndex === this.indexLastInspeccionNoBorrada;
    }
}
